<template>
  <button @click="leave" :class="['btn', $style.button]">Leave Call</button>
</template>

<script>
  import { leftNotification } from './notifications'

  export default {
    methods: {
      leave () {
        leftNotification().show()
        this.$router.push({path: '/live-coach'})
      }
    }
  }
</script>

<style module lang="less" src="./leave-button.less"></style>



// WEBPACK FOOTER //
// leave-button.vue?a1c6d3c2